import React from 'react';
import StackIcon from 'tech-stack-icons';

const skills = [
  {
    icon: 'react',
    name: 'React.js',
  },
  {
    icon: 'nodejs',
    name: 'Node.js',
  },
  {
    icon: 'js',
    name: 'Javascript',
  },
  {
    icon: 'python',
    name: 'Python',
  },
  {
    icon: 'tailwindcss',
    name: 'Tailwind CSS',
  },
  {
    icon: 'html5',
    name: 'HTML',
  },
  {
    icon: 'css3',
    name: 'CSS',
  },
  {
    icon: 'figma',
    name: 'Figma',
  },
  {
    icon: 'expressjs',
    name: 'Express.js',
  },
  {
    icon: 'flask',
    name: 'Python Flask',
  },
  {
    icon: 'mysql',
    name: 'MySQL',
  },
  {
    icon: 'mongodb',
    name: 'MongoDB',
  },
  {
    icon: 'supabase',
    name: 'Supabase',
  },
  {
    icon: 'git',
    name: 'Git',
  },
  {
    icon: 'github',
    name: 'Github',
  },
  {
    icon: 'vuejs',
    name: 'Vue.js',
  },
];

export default function Skills() {
  return (
    <section id="skills" className="container skills">
      <h2>Skills</h2>
      <div className="skill-list">
        {skills.map((s) => (
          
            <div style={{ width: 50, height: 50 }}>
              <StackIcon name={s.icon} />
              <p>{s.name}</p>
            </div>
        ))}
      </div>
    </section>
  );
}
